// helper function to format date input with slashes
// ideally we'd use react-imask here, but couldn't get it to work with antd / dayjs
// example from https://stackoverflow.com/questions/44137998/auto-slash-for-date-input-using-javascript

import React from 'react';
import dayjs from 'dayjs';

import { DATE_FORMAT } from 'consts/placeholders';

const checkValue = (stringValue: string, max: number) => {
  if (stringValue.charAt(0) !== '0' || stringValue === '00') {
    let num = parseInt(stringValue);
    if (isNaN(num) || num <= 0 || num > max) num = 1;
    stringValue =
      num > parseInt(max.toString().charAt(0)) && num.toString().length === 1
        ? '0' + num
        : num.toString();
  }

  return stringValue;
};

const formatWithSlashes = (val: string): string => {
  if (/\D\/$/.test(val)) val = val.substring(0, val.length - 3);

  const values = val.split('/').map((inputCharacter: string) => {
    return inputCharacter.replace(/\D/g, ''); // if you mix numbers and any other characters return only numbers[]
  }); // -> ['04', '03', '2003']

  if (values[0]) values[0] = checkValue(values[0], 31);
  if (values[1]) values[1] = checkValue(values[1], 12);

  const output = values.map((value: string, index: number) => {
    return value.length === 2 && index < 2 ? value + '/' : value;
  });

  return output.join('').substring(0, 14);
};

export const handleOnKeyDown = (event: React.KeyboardEvent<HTMLElement>, setValue: any) => {
  const input = event.target as HTMLInputElement;
  const currentValue = input.value;
  const cursorPosition = input.selectionStart || 0;

  // Check for numeric keys and the backspace key
  if (/[\d\b]/.test(event.key)) {
    const newValue =
      currentValue.slice(0, cursorPosition) + event.key + currentValue.slice(cursorPosition);
    const formattedValue = formatWithSlashes(newValue);

    const dayjsValue = dayjs(formattedValue, DATE_FORMAT);
    if (dayjsValue.isValid()) {
      setValue(dayjsValue);
    }
    input.value = formattedValue;

    // Calculate the new cursor position based on the difference in string length
    const lengthDiff = formattedValue.length - currentValue.length;
    const newCursorPosition = cursorPosition + lengthDiff;
    // Set the cursor position after modification
    input.setSelectionRange(newCursorPosition, newCursorPosition);
    event.preventDefault();
  } else if (event.key === 'Backspace') {
    // Handle backspace separately to ensure correct behavior
    const newValue = currentValue.slice(0, cursorPosition - 1) + currentValue.slice(cursorPosition);
    const formattedValue = formatWithSlashes(newValue);
    const dayjsValue = dayjs(formattedValue, DATE_FORMAT);
    if (dayjsValue.isValid()) {
      setValue(dayjsValue);
    }
    input.value = formattedValue;
    // Calculate the new cursor position after backspace
    const newCursorPosition = Math.max(0, cursorPosition - 1);
    // Set the cursor position after modification
    input.setSelectionRange(newCursorPosition, newCursorPosition);
    event.preventDefault();
  }
};
